import moment from 'moment'
import { PLATFORM_VALUE, } from 'meinian-package/src/component/platformConfig'

// const BLOCKBUSTER_COLUMN = { AD: '广告大片', OOTD: '搭配手册', MAG: '杂志大片' }

const getFilename = (platformId, dto, sourceTime, item) => {
  let name = ''
  switch (Number(platformId)) {
    case PLATFORM_VALUE.SHOW:
      name = `${dto.brand ? (`${dto.brand}_`) : ''}${dto.season ? (`${dto.season}_`) : ''}${dto.city ? (`${dto.city}_`) : ''}发布会.jpg`
      break
    case PLATFORM_VALUE.BRAND:
      name = `${dto.brand ? (`${dto.brand}_`) : ''}${dto.season ? (`${dto.season}_`) : ''}${dto.city ? (`${dto.city}_`) : ''}${item?.boxLabelRetList?.[0]?.labelArray?.[1] || item?.boxLabelRetList?.[0]?.finalLabelArray?.find(m => m.type === 1)?.tag || ''}.jpg`
      break
    case PLATFORM_VALUE.WHOLESALE:
      name = `${dto.season ? (`${dto.season}_`) : ''}批发市场.jpg`
      break
    case PLATFORM_VALUE.RETAIL:
      name = `${dto.season ? (`${dto.season}_`) : ''}零售市场.jpg`
      break
    case PLATFORM_VALUE.INS:
      name = `${dto.bloggerObj?.nickName ? (`${dto.bloggerObj?.nickName}_`) : ''}${moment(sourceTime).format('YYYYMMDD')}_INS款式.jpg`
      break
    case PLATFORM_VALUE.ITEM:
      name = `${dto.shopName ? (`${dto.shopName}_`) : ''}${moment(sourceTime).format('YYYYMMDD')}_电商款式.jpg`
      break
    case PLATFORM_VALUE.XIAOHONGSHU:
      name = `${dto.bloggerObj?.nickname ? (`${dto.bloggerObj?.nickname}_`) : ''}${moment(sourceTime).format('YYYYMMDD')}_小红书.jpg`
      break
    case PLATFORM_VALUE.DY:
      name = `${dto.shopName ? (`${dto.shopName}_`) : ''}${moment(sourceTime).format('YYYYMMDD')}_抖音商品.jpg`
      break
    case PLATFORM_VALUE.UPLOAD:
      name = `${dto.userObj?.userName ? (`${dto.userObj?.userName}_`) : ''}${moment(sourceTime).format('YYYYMMDD')}_上传灵感.jpg`
      break
    case PLATFORM_VALUE.DW:
      name = `${dto.brand ? (`${dto.brand}_`) : ''}${dto.season ? (`${dto.season}_`) : ''}得物.jpg`
      break
    // case PLATFORM_VALUE.STREET:
    //   name = `${dto.modelName ? (`${dto.modelName}_`) : ''}${dto.season ? (`${dto.season}_`) : ''}街拍.jpg`
    //   break
    // case PLATFORM_VALUE.ORDER:
    //   name = `${dto.brand ? (`${dto.brand}_`) : ''}${dto.season ? (`${dto.season}_`) : ''}订货会.jpg`
    //   break
    case PLATFORM_VALUE.INSGOODS:
      name = `${dto.bloggerObj?.nickName ? (`${dto.bloggerObj?.nickName}_`) : ''}${moment(sourceTime).format('YYYYMMDD')}_INS商品.jpg`
      break
    case PLATFORM_VALUE.FARFETCH:
      name = `${dto.brand ? (`${dto.brand}_`) : ''}_发发奇.jpg`
      break
    // case PLATFORM_VALUE.NET_A_PORTER:
    //   name = `${dto.brand ? (`${dto.brand}_`) : ''}_NET-A-PORTER.jpg`
    //   break
    case PLATFORM_VALUE.SSENSE:
      name = `${dto.brand ? (`${dto.brand}_`) : ''}_SSENSE.jpg`
      break
    case PLATFORM_VALUE.SHOPBOP:
      name = `${dto.brand ? (`${dto.brand}_`) : ''}_shopbop.jpg`
      break
    // case PLATFORM_VALUE.BLOCKBUSTER:
    //   if (dto.columnName === BLOCKBUSTER_COLUMN.MAG) {
    //     name = `${dto.magazineName ? (`${dto.magazineName}_`) : ''}${dto.season ? (`${dto.season}_`) : ''}${dto.city ? (`${dto.city}_`) : ''}${dto.columnName}.jpg`
    //   } else {
    //     name = `${dto.brand ? (`${dto.brand}_`) : ''}${dto.season ? (`${dto.season}_`) : ''}${dto.city ? (`${dto.city}_`) : ''}${dto.columnName}.jpg`
    //   }
    //   break
    // case PLATFORM_VALUE.SHOW_DETAIL:
    //   name = `${dto?.runwayDataDTO?.brand ? (`${dto?.runwayDataDTO?.brand}_`) : ''}${dto?.runwayDataDTO?.season ? (`${dto?.runwayDataDTO?.season}_`) : ''}${dto?.runwayDataDTO?.city ? (`${dto?.runwayDataDTO?.city}_`) : ''}发布会${dto.contentType || ''}.jpg`
    //   break
    case PLATFORM_VALUE.TAOBAO_ZHI_DA:
      name = `${dto.collocationTitle}${dto.startTime}_淘系搭配.jpg`
      break
    case PLATFORM_VALUE.ZHI_XIAO_HONG:
      name = `${dto.nickname}${dto.publishTime}_知小红.jpg`
      break
    case PLATFORM_VALUE.CROSSBORDER_PINTEREST:
      name = `${dto.nickName}_${moment(sourceTime).format('YYYYMMDD')}_Pinterest.jpg`
      break
    case PLATFORM_VALUE.PINTEREST:
      name = `${dto.nickName}_${moment(sourceTime).format('YYYYMMDD')}_Pinterest款式.jpg`
      break
    case PLATFORM_VALUE.MUSINSA:
      name = `${dto.brand ? (`${dto.brand}_`) : ''}_MUSINSA.jpg`
      break
    default:
      name = `${new Date().getTime()}.jpg`
  }
  return name
}

export default (platformId, currentDto, sourceTime) => { // 跨境 数据源
  let _platformId = platformId
  let name = ''
  switch (platformId) {
    case PLATFORM_VALUE.CROSSBORDER_INS: _platformId = PLATFORM_VALUE.INS; break
    case PLATFORM_VALUE.CROSSBORDER_INS_GOODS: _platformId = PLATFORM_VALUE.INSGOODS; break
    case PLATFORM_VALUE.CROSSBORDER_SHOW: _platformId = PLATFORM_VALUE.SHOW; break
    case PLATFORM_VALUE.DY_WORKS:
      name = `${currentDto.shopName ? (`${currentDto.shopName}_`) : ''}${moment(sourceTime).format('YYYYMMDD')}_抖衣作品.jpg`
      break
    default: _platformId = platformId
  }
  if (name) {
    return name
  }
  return getFilename(_platformId, currentDto, sourceTime)
}
